module.exports = __webpack_public_path__ + "img/60375c73f0a81303b7aaebc1b98159b4.f707727c.png";